////
/// ============================================================================
/// COMPONENT / Swiper Home
/// ============================================================================
///
/// @link https://swiperjs.com/
/// @link https://codepen.io/xgad/post/svg-radial-progress-meters
/// @group components
////

import Swiper, {Autoplay, Controller, Navigation, Pagination} from 'swiper';

Swiper.use([Autoplay, Controller, Navigation, Pagination]);

export default () => {

    let container = document.querySelector('.js-home-slideshow-main');
    let progressValue = document.querySelector('.c-progress__value');

    if (!container || !progressValue) {
        return;
    }

    let circumference = 2 * Math.PI * progressValue.getAttribute('r');
    let duration;
    let delayBeforeStartAnimation = 10;

    function startPaginationAnimation() {
        progressValue.style.transitionProperty = 'none';
        progressValue.style.transitionDuration = 'unset';
        progressValue.style.strokeDashoffset = circumference;

        setTimeout(function () {
            progressValue.style.transitionProperty = 'stroke-dashoffset';
            progressValue.style.transitionDuration = duration + 'ms';
            progressValue.style.strokeDashoffset = 0;
        }, delayBeforeStartAnimation);
    }

    let main = new Swiper(container, {
        speed: 1000,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            waitForTransition: false
        },
        on: {
            init: function () {
                duration = this.params.autoplay.delay - delayBeforeStartAnimation;

                progressValue.style.strokeDasharray = circumference;
                progressValue.style.transitionTimingFunction = 'linear';

                startPaginationAnimation();
            },
            transitionStart: function () {
                startPaginationAnimation();
            },
        },
        pagination: {
            el: '.js-home-slideshow-fraction',
            type: 'fraction',
        },
    });

    let images = new Swiper('.js-home-slideshow-images');

    // sync
    main.controller.control = images;
    images.controller.control = main;

};
